export default {
    nav: {
        home: 'الرئيسية',
        about: 'نبذة',
        certifications: 'الشهادات',
        portfolio: 'الأعمال',
        services: 'الخدمات',
        contact: 'تواصل',
        language: {
            en: 'الإنجليزية',
            ar: 'العربية',
            tr: 'التركية',
        },
    },
    hero: {
        kicker: 'ملف أعمال Code Dragon',
        title: 'اسمي محمد. وأنا مطور مواقع ويب، وهنا لا أطور لك فقط موقع بل أمنحك تجربة فريدة',
        subtitle:
            'أحوّل الأفكار إلى واجهات متجاوبة وتفاعلية تجمع بين التصميم النظيف، الأداء العالي، وتجربة استخدام مريحة.',
        cta: 'شاهد أعمالي',
        secondaryCta: 'تواصل معي',
        badges: {
            javascript: 'JavaScript',
            responsive: 'واجهات متجاوبة',
            performance: 'أداء عالي',
        },
    },
    about: {
        title: 'نبذة عني',
        paragraph1:
            'أنا محمد غريب الأحمد، طالب برمجة حاسوب في جامعة الأناضول ومطوّر ويب معتمد. أتخصص في بناء واجهات ويب حديثة عالية الأداء باستخدام HTML وCSS وJavaScript وBootstrap.',
        paragraph2:
            'باستخدام أدوات مثل Vite وأحدث اتجاهات التصميم، أقدّم مواقع سريعة وسهلة الاستخدام في Code Dragon. هدفي تحويل الأفكار إلى تجارب رقمية سلسة حيث يلتقي الكود النظيف بالتصميم المميز.',
        code: `const frontendDev = {
  name: "محمد غريب الأحمد",
  role: "مطوّر واجهات أمامية",
  skills: ["HTML/CSS", "JavaScript", "React"],
  focus: ["الأداء", "الوصول", "تجربة المستخدم"]
}`,
    },
    skills: {
        html: 'HTML5 و CSS3',
        js: 'JavaScript / ES6+',
        react: 'React',
        sass: 'SASS/SCSS',
        bootstrap: 'Bootstrap',
        tailwind: 'Tailwind CSS',
        vite: 'Vite و Webpack',
        git: 'Git و GitHub',
        responsive: 'تصميم متجاوب',
    },
    certifications: {
        title: 'الشهادات والإنجازات',
        subtitle: 'شهادات احترافية وتعلّم مستمر في تطوير الويب',
        responsive: {
            title: 'تصميم ويب متجاوب',
            issuer: 'Udemy',
            date: '2023',
            description:
                'شهادة في بناء مواقع متجاوبة باستخدام HTML5 وCSS3 ومبادئ التصميم المعتمدة على الجوال أولا.',
            skills: {
                html: 'HTML5',
                css: 'CSS3',
                mobile: 'نهج الجوال أولا',
            },
        },
        ai: {
            title: 'الذكاء الاصطناعي للجميع',
            issuer: 'Google / Coursera',
            date: '2026',
            description:
                'توظيف أدوات وتقنيات الذكاء الاصطناعي لرفع الإنتاجية وتبسيط سير عمل التطوير.',
            skills: {
                tools: 'أدوات الذكاء الاصطناعي',
                prompt: 'هندسة الأوامر',
            },
        },
        webInterface: {
            title: 'تطوير واجهات ويب',
            issuer: 'Hsoub Academy',
            date: '2026',
            description:
                'شهادة احترافية في تطوير واجهات الويب، تُظهر الخبرة في بناء واجهات حديثة عالية الأداء ومتجاوبة.',
            skills: {
                web: 'تطوير الويب',
                responsive: 'تصميم متجاوب',
                performance: 'الأداء',
            },
        },
    },
    portfolio: {
        title: 'أبرز المشاريع',
        projectPizza: {
            title: 'مشروع مطعم بيتزا',
            description:
                'موقع مطعم حديث ومتجاوب بالكامل مبني بـ Vanilla JavaScript ومحسّن عبر Webpack لأداء أعلى. يتضمن قائمة تفاعلية وسلة مشتريات وتقييمات العملاء.',
            live: 'عرض مباشر',
            github: 'GitHub',
        },
        projectMajalis: {
            title: 'مجالس الورّاقين',
            description:
                'صفحة هبوط عربية حديثة وتفاعلية تدعم RTL بالكامل، بتصميم مستوحى من النيون، مؤثرات حركية سلسة، وتنبيهات تفاعلية لتجربة سريعة وجذابة.',
            live: 'عرض مباشر',
        },
        modal: {
            fallbackDescription: 'تفاصيل المشروع قريباً.',
            featuresTitle: 'الميزات الرئيسية',
            techTitle: 'التقنيات',
            close: 'إغلاق',
            projects: {
                ecommerce: {
                    title: 'منصة تجارة إلكترونية',
                    description:
                        'حل تجارة إلكترونية متكامل بإدارة مخزون فورية وسلة مشتريات ومعالجة دفع آمنة باستخدام Stripe.',
                    features: [
                        'إدارة مخزون فورية',
                        'سلة مشتريات مع حفظ دائم',
                        'معالجة دفع آمنة',
                        'توثيق المستخدمين والملفات الشخصية',
                        'نظام تتبع الطلبات',
                        'لوحة تحكم للمشرف',
                    ],
                },
                analytics: {
                    title: 'لوحة تحليلات',
                    description:
                        'لوحة تصوّر بيانات تفاعلية بمؤشرات فورية وفلاتر متقدمة وإمكانات تصدير لذكاء الأعمال.',
                    features: [
                        'تصوّر بيانات فوري',
                        'فلاتر وبحث متقدم',
                        'لوحات قابلة للتخصيص',
                        'تصدير إلى CSV/PDF',
                        'أنواع متعددة من المخططات',
                        'مؤشرات أداء',
                    ],
                },
                tasks: {
                    title: 'تطبيق إدارة مهام',
                    description:
                        'أداة تعاونية لإدارة المهام بتحديثات فورية وخصائص تعاون وواجهة سحب وإفلات سهلة.',
                    features: [
                        'إنشاء وإدارة المهام',
                        'واجهة سحب وإفلات',
                        'تعاون الفريق',
                        'تحديثات فورية',
                        'تذكير بمواعيد الاستحقاق',
                        'مستويات أولوية',
                    ],
                },
            },
        },
    },
    features: {
        title: 'ماذا أقدم',
        subtitle: 'خدمات احترافية لتطوير الواجهات الأمامية لتحويل أفكارك إلى مواقع فعالة',
        items: {
            responsive: {
                title: 'تطوير ويب متجاوب',
                description: 'بناء مواقع متجاوبة تعمل بسلاسة على جميع الأجهزة ومقاسات الشاشات.',
                list: ['نهج الجوال أولا', 'توافق متعدد المتصفحات', 'تخطيطات وشبكات مرنة', 'واجهات ملائمة للمس'],
            },
            modernJs: {
                title: 'تطوير JavaScript حديث',
                description: 'إنشاء تطبيقات ويب تفاعلية وديناميكية باستخدام أحدث أطر JavaScript.',
                list: ['تطبيقات React و Vue.js', 'أفضل ممارسات ES6+', 'حلول إدارة الحالة', 'تكامل APIs'],
            },
            ui: {
                title: 'تنفيذ واجهات UI',
                description: 'تحويل التصاميم والنماذج إلى واجهات ويب دقيقة وعملية.',
                list: ['تحويل Figma/XD إلى كود', 'حركات CSS وانتقالات', 'هيكلية تعتمد المكونات', 'دمج أنظمة التصميم'],
            },
            performance: {
                title: 'تحسين الأداء',
                description: 'ضمان تحميل الموقع بسرعة وتشغيله بسلاسة لأفضل تجربة مستخدم.',
                list: ['تقسيم الشيفرة والتحميل الكسول', 'تحسين الصور', 'تقليل حجم الحزمة', 'مراقبة الأداء'],
            },
            accessibility: {
                title: 'إتاحة الويب',
                description: 'جعل موقعك متاحا لجميع المستخدمين بمن فيهم ذوو الإعاقة.',
                list: ['الامتثال لمعايير WCAG', 'دعم قارئات الشاشة', 'التنقل عبر لوحة المفاتيح', 'بنية HTML دلالية'],
            },
            maintenance: {
                title: 'صيانة الشيفرة والتحديثات',
                description: 'الحفاظ على شيفرة الواجهة الأمامية نظيفة ومحدّثة وسهلة الصيانة.',
                list: ['إصلاح الأخطاء والتحديثات', 'إعادة هيكلة الشيفرة', 'توثيق', 'إدارة الإصدارات عبر Git'],
            },
        },
    },
    contact: {
        title: 'تواصل معي',
        namePlaceholder: 'اسمك',
        emailPlaceholder: 'بريدك الإلكتروني',
        messagePlaceholder: 'رسالتك',
        submit: 'إرسال الرسالة',
        sending: 'جار الإرسال...',
    },
    footer: {
        rights: '© 2026 ملف أعمال Code Dragon. جميع الحقوق محفوظة.',
    },
    alerts: {
        successTitle: 'تم إرسال الرسالة بنجاح! ✅',
        successBody:
            'شكرا لك، <strong style="color: #c5a059;">{{name}}</strong>!<br>تم إرسال رسالتك بنجاح!',
        successConfirm: 'رائع!',
        errorTitle: 'خطأ! ❌',
        errorText: 'عذرا، حدث خطأ ما. يرجى المحاولة مرة أخرى.',
        errorConfirm: 'حسنا',
        warningTitle: 'تنبيه! ⚠️',
        warningConfirm: 'حسنا',
        validation: {
            nameRequired: 'يرجى إدخال اسمك',
            nameShort: 'يجب أن يكون الاسم حرفين على الأقل',
            emailRequired: 'يرجى إدخال بريدك الإلكتروني',
            emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
            messageRequired: 'يرجى إدخال رسالتك',
            messageShort: 'يجب أن تكون الرسالة 10 أحرف على الأقل',
        },
    },
};
